import { request } from './request'
// 获取机构结算记录分页列表
function getOrgSettleRecordList(data) {
    return request({
        url: '/sys/orgSettleRecord/selectListPage',
        method: 'POST',
        data: data
    })
}

//保存
function orgSettleRecordSave(data) {
    return request({
        url: '/sys/orgSettleRecord/orgSettleRecordSave',
        method: 'POST',
        data: data
    })
}

//根据合同ID查询机构合同详情
function getOrgSettleRecord(data) {
    return request({
        url: '/sys/orgSettleRecord/getOrgSettleRecord',
        method: 'POST',
        data: data
    })
}
//导出
function exportOrgSettleRecord(data) {
    return request({
        url: '/sys/orgSettleRecord/exportData',
        method: 'POST',
        responseType: 'blob',
        data: data
    })
}

export default {
    getOrgSettleRecordList,
    orgSettleRecordSave,
    getOrgSettleRecord,
    exportOrgSettleRecord
}
